import { VideoCard } from 'Components/common/Cards/VideoCard/VideoCard'
import styles from '../../Home.module.less'
import { EmptyStateIndicator } from 'Components/common/EmptyStaleIndicator/EmptyStaleIndicator'
import { useExamList } from 'Hooks/exams/use-exam-list'
import { ExamCard } from './ExamCard'
import { CardListSkeleton } from 'Components/common/CardListSkeleton/CardListSkeleton'

export const AvailableExamsTab: React.FC = () => {
    const { data, isLoading } = useExamList()

    return (
        <div className={styles['available-exams-tab']} data-testid="available-exams-tab">
            <div className={styles['exam-list-container']} data-testid="exam-list">
                {isLoading && <CardListSkeleton />}
                {!data?.exams.length && !isLoading ? (
                    <EmptyStateIndicator
                        label={'No exams found'}
                        caption="Please refresh or check again later to see if any new tasks are available for you"
                    />
                ) : (
                    data?.exams.map(exam => <ExamCard exam={exam} key={exam.id} />)
                )}
            </div>
            <div className={styles['tutorial-container']}>
                <p className={styles['tutorial-title']}>Help & Tutorials</p>
                <VideoCard
                    title="Exam Intro Video"
                    description="The above video provides details about the exam interface tool"
                />
            </div>
        </div>
    )
}
